export default __webpack_public_path__ + "static/media/040-bucket.824a69cc.svg";